import axios from 'axios';

const PREFIJO="/api/MdlCmcl/";

export default {
    idmodelo(seleccion) {
        const dto={id:seleccion};
        return axios.post(`${PREFIJO}VmSlIdM`,dto);
    },

    idVersionComercial(seleccion,anio) {
        const dto={
            id:seleccion.id,
            ndt2:seleccion.ndt2,
            ndt3:anio,
        };
        return axios.post(`${PREFIJO}VmSlIMC`,dto);
    },
};
